import { useRef, useEffect } from 'react';
import ScrollReveal from 'scrollreveal';
import styles from './CourseCard.module.css';
import { LuArrowLeft, LuCalendarDays, LuMapPin } from 'react-icons/lu';

const CourseCard = ({ course, onSyllabusClick, index = 0 }) => {
  const ref = useRef(null);
  const contentRef = useRef(null);
  const isFlagship = course.id === 'triple';

  useEffect(() => {
    if (contentRef.current) {
      const sr = ScrollReveal();
      const children = contentRef.current.children;
      sr.reveal(children, {
        origin: 'bottom',
        distance: '18px',
        duration: 600,
        delay: 150 + index * 100,
        interval: 90,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        reset: false,
      });
    }
  }, [index]);

  return (
    <article
      ref={ref}
      className={`${styles.card} ${isFlagship ? styles.flagship : ''}`}
      onClick={() => onSyllabusClick(course)}
    >
      {/* Flagship diagonal ribbon */}
      {isFlagship && (
        <div className={styles.ribbon}>
          <span className={styles.ribbonText}>קורס הדגל</span>
        </div>
      )}

      {/* Background image */}
      <div className={styles.imgWrap}>
        <img src={course.bgImage} alt="" className={styles.img} loading="lazy" />
        <div className={styles.imgOverlay} />
      </div>

      {/* Inner double-frame */}
      <div className={styles.frame} />

      {/* Content at bottom  -  elements animate in */}
      <div className={styles.content} ref={contentRef}>
        <div className={styles.ornament}>
          <span className={styles.ornLine} />
          <span className={styles.ornStar}>✦</span>
          <span className={styles.ornLine} />
        </div>

        <h3 className={styles.title}>{course.title}</h3>
        <p className={styles.subtitle}>{course.subtitle}</p>

        <div className={styles.metaRow}>
          <span className={styles.metaItem}>
            <LuCalendarDays className={styles.metaIcon} />
            {course.duration}
          </span>
          <span className={styles.metaDot} />
          <span className={styles.metaItem}>
            <LuMapPin className={styles.metaIcon} />
            {course.location}
          </span>
        </div>

        <button
          className={styles.cta}
          onClick={(e) => { e.stopPropagation(); onSyllabusClick(course); }}
        >
          <span>לסילבוס המלא</span>
          <LuArrowLeft className={styles.ctaArrow} />
        </button>
      </div>
    </article>
  );
};

export default CourseCard;
